<template>
	<!-- Main Content Area -->
    <div class="archiveSkills">
        <!-- Main Body Content area -->

        <div class="o-ndividualArea c-responsive-fixwidth">
            <div class="o-ndividualTable">
                <div class="c-common-space o-individual-calls">
                    <div class="col-md-12 o-no-padding">
                        <!-- <form class="form-inline">
                            <div class="form-group">
                                <label class="common-label-text">Sort By:</label>
                                <div class="o-cutsomSelect o-cutsomSelect--fixedwidth">
                                    <select>
                                        <option selected>Select 1</option>
                                        <option>Select 2</option>
                                        <option>Select 3</option>
                                        <option>Select 4</option>
                                    </select>
                                </div>

                            </div>
                            <button type="submit" class="c-common-btn c-common-btn--green">Go</button>
                        </form> -->
                    </div>
                </div>

                <div class="o-skills-listing" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
                    <div class="row">
                        <div v-for="skill in skills" class="col col-sm-4">
                            <div class="o-skill-box c-common-gradient c-common-box-shadow">
                                <div class="skill-box-left">
                                    <div class="skill-title">{{(skill.name)? skill.name : "NA"}}</div>
                                    <div class="skill-details">
                                        <div class="skill-details-box">
                                            <p><span>Employees</span></p>
                                            <p>{{(skill.employees_ids) ? skill.employees_ids.length : "0"}}</p>
                                        </div>
                                        <div class="skill-details-box">
                                            <p><span>Priority</span></p>
                                            <p>{{(skill.priotiy)? skill.priotiy : "NA"}}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="skill-box-right">
                                    <div @click="removeAarchiveSkill(skill.id)"><i class="fa fa-external-link" aria-hidden="true"></i></div>
                                </div>
                            </div>
                        </div>

                        <div v-if="skills.length == 0" class="">
                            <div class="c-common-space c-common-gradient c-common-box-shadow c-radius3">
                                <div class="col-md-12 no-job-dispaly">
                                    <i class="fa fa-frown-o" aria-hidden="true"></i>
                                    <br />
                                    No Data Stored
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
        <!-- /Main Body Content area -->

    </div>
    <!-- /Main Content Area -->
</template>
<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../../services.js';
    export default {
        data() {
            return {
                skills: [],
                next_page: '',
                total: 0,
                storeMore: [],
                page_no: 1,
            }
        },
        props: ['myProp'],
        watch: {
            myProp: function(newVal) { // watch it
                //console.log('Prop changed: ', newVal);

                if (newVal == "") {
                    this.getArchiveSkills();
                } else {
                    if (newVal.length > 3) {
                        service.get('skill/searchSkills', {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'cs3-context-clientId': this.userClientID,
                                'skillSearch': newVal,
                                'search-type': 'archieved',
                            })
                            .then((res) => {
                                this.searchData = res.data.result;
                                this.skills = [];
                                for (var i = 0; i < this.searchData.length; i++) {
                                    if (this.searchData[i].archived == 1) {
                                        this.skills.push(this.searchData[i]);
                                    }

                                }
                            }).catch((err) => {
                                console.log(err);
                            })
                    }
                }
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userID: 'userID',
                userClientID: "userClientID",
            }),
        },
        methods: {
            loadMore() {
                var arr = this.skills;
                if (this.storeMore.length != 0) {
                    this.storeMore.forEach(function(entry) {
                        arr.push(entry);
                    })
                    this.storeMore = [];
                    if (this.next_page != null || this.next_page != "") {
                        service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                        }).then((res) => {
                            this.storeMore = res.data.result.data;
                            this.page_no += 1;
                            this.next_page = res.data.result.next_page_url;

                        }).catch((err) => {
                            console.log(err);
                        });
                    }
                } else
                    this.storeMore = [];
            },
            getArchiveSkills() {
                this.$Progress.start();
                service.get('skill/getArchivedSkills', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                }).
                then((res) => {
                    this.skills = res.data.result.data;
                    //console.log(this.skills);
                    this.total = res.data.result.total;
                    this.$Progress.finish();
                    this.next_page = res.data.result.next_page_url;
                    if (this.next_page != null || this.next_page == "") {
                        service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                        }).then((more) => {
                            this.storeMore = more.data.result.data;
                            //console.log(more);
                        }).catch((err) => {
                            console.log(err);
                        });
                    }
                }).catch((err) => {
                    console.log(err);
                    this.$Progress.finish();
                });
            },
            removeAarchiveSkill(skillId) {
                this.$confirm('This will permanently remove the archive skill. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    //this.$Progress.start();
                    service.get('skill/' + skillId + '/removeFromArchiveSkill', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                    }).
                    then((res) => {
                        this.$Progress.finish();
                        this.$message({
                            type: 'success',
                            message: 'Archive removed successfully.'
                        });
                        this.skills = [];
                        this.getArchiveSkills();
                    }).catch((err) => {
                        console.log(err);
                        this.$Progress.finish();
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Request canceled.'
                    });
                });
            }
        },
        created() {
            this.getArchiveSkills();
        }
    }

</script>
<style scoped>


</style>



// WEBPACK FOOTER //
// src/components/skills/archiveSkills.vue